import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '../components/index_navigation'
import index from '../components/index'
import indexMy from '../components/index_my'


Vue.use(Router)

const router = new Router({
  routes: [{
      path: '/',
      name: 'app',
      redirect: '/home'
    }, {
      path: '/home',
      component: HomePage,
      redirect: '/home/mz',
      children: [{
        path: 'mz',
        component: index,
        meta: {
          title: '周口市人民医院'
        },
        beforeEnter: (to, from, next) => {
          if (from.name == 'chooseTime1') {
            // 预约成功跳转至预约记录
            next('/regonline')
          }
          next()
        }
      }, {
        path: 'my',
        component: indexMy,
        meta: {
          title: '周口市人民医院'
        }
      }]
    }, {
      path: '/patientList',
      name: 'patientList',
      component: resolve => require(['@/components/outpatient_patient_list'], resolve),
      /*就诊人列表*/
      meta: {
        title: '就诊人列表'
      }
    }, {
      path: '/patientAdd',
      name: 'patientAdd',
      component: resolve => require(['@/components/outpatient_patient_add'], resolve),
      /*添加就诊人*/
      meta: {
        title: '添加就诊人'
      }
    }, {
      path: '/patientComplate',
      name: 'patientComplate',
      component: resolve => require(['@/components/outpatient_patient_add_complate'], resolve),
      meta: {
        title: '完善就诊人信息'
      }
    }, {
      path: '/patientDetails',
      name: 'patientDetails',
      component: resolve => require(['@/components/outpatient_patient_details'], resolve),
      meta: {
        title: '就诊人信息'
      }
    }, {
      path: '/NoPatient',
      name: 'NoPatient',
      component: resolve => require(['@/components/outpatient_patient_noadd'], resolve),
      /*添加就诊人*/
      meta: {
        title: '添加就诊人'
      }
    }, {
      path: '/patientbind01',
      name: 'patientbind01',
      component: resolve => require(['@/components/outpatient_patient_bind01'], resolve),
      /*绑定就诊卡*/
      meta: {
        title: '添加就诊人',
        // keepAlive: true
      }
    }, {
      path: '/patientbind02',
      name: 'patientbind02',
      component: resolve => require(['@/components/outpatient_patient_bind02'], resolve),
      meta: {
        title: '添加就诊人'
      }
    }, {
      path: '/patientbind02havecard',
      name: 'havecard',
      component: resolve => require(['@/components/outpatient_patient_bind02_havecard'], resolve),
      meta: {
        title: '添加就诊人-有卡建档'
      }
    }, {
      path: '/patientbind02nocard',
      name: 'patientbind02nocard',
      component: resolve => require(['@/components/outpatient_patient_bind02_nocard'], resolve),
      meta: {
        title: '添加就诊人-无卡建档'
      }
    }, {
      path: '/patientbind02cardres',
      name: 'cardres',
      component: resolve => require(['@/components/outpatient_patient_bind02_cardres'], resolve),
      meta: {
        title: '添加就诊人-就诊卡信息'
      }
    }, {
      path: '/patientbind02cardlist',
      name: 'cardlist',
      component: resolve => require(['@/components/outpatient_patient_bind02_cardlist'], resolve),
      meta: {
        title: '添加就诊人-选择就诊卡'
      }
    },
    {
      path: "/registe-new",
      name: "HealthCard-RegisteNew",
      component: resolve => require(["@/components/wxHealthCard/registe_new"], resolve),
      meta: {
        title: "注册/绑定电子健康卡"
      }
    },
    {
      path: "/healthcard-list",
      name: "HealthCard-List",
      component: resolve => require(["@/components/wxHealthCard/list"], resolve),
      meta: {
        title: "电子健康卡"
      }
    },
    {
      path: "/healthcard-personal",
      name: "HealthCard-Personal",
      component: resolve => require(["@/components/wxHealthCard/personal"], resolve),
      meta: {
        title: "电子健康卡信息"
      }
    },
    {
      path: "/healthcard-upgrade",
      name: "HealthCard-Upgrade",
      component: resolve => require(["@/components/wxHealthCard/upgrade"], resolve),
      meta: {
        title: "升级健康卡"
      }
    },
    {
      path: "/healthcard-oauth",
      name: "HealthCard-Oauth",
      component: resolve => require(["@/components/wxHealthCard/oauth_registe"], resolve),
      meta: {
        title: "电子健康卡"
      }
    }, {
      path: '/accountChargeWx',
      name: 'accountChargeWx',
      component: resolve => require(['@/components/account-charge-wx'], resolve),
      /*微信就诊卡充值*/
      meta: {
        title: '就诊卡充值'
      }
    }, {
      path: '/patientCharge',
      name: 'patientCharge',
      component: resolve => require(['@/components/outpatient_patient_charge'], resolve),
      /*微信就诊卡充值*/
      meta: {
        title: '就诊卡充值记录'
      }
    }, {
      path: '/accountChargeAli',
      name: 'accountChargeAli',
      component: resolve => require(['@/components/account-charge-ali'], resolve),
      /*支付宝就诊卡充值*/
      meta: {
        title: '就诊卡充值'
      }
    }, {
      path: '/patientcode',
      name: 'patientcode',
      component: resolve => require(['@/components/outpatient_patient_code'], resolve),
      /*二维码*/
      meta: {
        title: '二维码'
      }
    }, {
      path: '/sharecard',
      name: 'sharecard',
      component: resolve => require(['@/components/outpatient_patient_sharecard'], resolve),
      /*分享二维码*/
      meta: {
        title: '分享二维码'
      }
    }, {
      path: '/hospitalizationSearch/:type',
      name: 'hospitalizationSearch',
      component: resolve => require(['@/components/hospitalization_search'], resolve),
      /*住院搜索*/
      meta: {
        title: '住院搜索'
      }
    }, {
      path: '/hospitalizationMessage',
      name: 'hospitalizationMessage',
      component: resolve => require(['@/components/hospitalization_message'], resolve),
      meta: {
        title: '住院信息'
      }
    }, {
      path: '/hospitalizationDetailedInfo',
      name: 'hospitalizationDetailedInfo',
      component: resolve => require(['@/components/hospitalization_detailed_info'], resolve),
      meta: {
        title: '住院信息',
        // keepAlive: true
      },
      beforeEnter: (to, from, next) => {
        if (from.name == 'hospitalizationDetailedList') {
          to.query.refresh = false
        } else {
          to.query.refresh = true
        }
        next()
      }
    }, {
      path: '/hospitalizationDetailedList',
      name: 'hospitalizationDetailedList',
      component: resolve => require(['@/components/hospitalization_detailed_list'], resolve),
      /*住院清单列表*/
      meta: {
        title: '住院清单列表'
      }
    }, {
      path: '/hospitalizationDetailed',
      name: 'hospitalizationDetailed',
      component: resolve => require(['@/components/hospitalization_detailed'], resolve),
      /*住院清单*/
      meta: {
        title: '住院清单'
      }
    }, {
      path: '/hospitalizationRecharge',
      name: 'hospitalizationRecharge',
      component: resolve => require(['@/components/hospitalization_recharge'], resolve),
      /*住院充值*/
      meta: {
        title: '住院充值'
      }
    }, {
      path: '/hospitalizationRechargeWx',
      name: 'hospitalizationRechargeWx',
      component: resolve => require(['@/components/hospitalization_recharge_wx'], resolve),
      /*住院充值-微信*/
      meta: {
        title: '住院充值'
      }
    }, {
      path: '/hospitalizationRechargeAli',
      name: 'hospitalizationRechargeAli',
      component: resolve => require(['@/components/hospitalization_recharge_ali'], resolve),
      /*住院充值-支付宝*/
      meta: {
        title: '住院充值'
      }
    }, {
      path: '/hospitalizationRechargeList',
      name: 'hospitalizationRechargeList',
      component: resolve => require(['@/components/hospitalization_recharge_list'], resolve),
      meta: {
        title: '充值记录'
      }
    }, {
      path: '/hospitalizationReport',
      name: 'hospitalizationReport',
      component: resolve => require(['@/components/hospitalization_report'], resolve),
      /*住院检查报告*/
      meta: {
        title: '报告查询',
        keepAlive: true
      },
      beforeEnter: (to, from, next) => {
        if (from.meta.isDetail) {
          to.query.back = true
        }
        next()
      }
    }, {
      path: '/hospitalizationReportCheckDetails',
      name: 'hospitalizationReportCheckDetails',
      component: resolve => require(['@/components/hospitalization_report_check_details'], resolve),
      /*住院检验报告-报告详情*/
      meta: {
        title: '报告详情',
        isDetail: true
      }
    }, {
      path: '/hospitalizationReportExamDetails',
      name: 'hospitalizationReportExamDetails',
      component: resolve => require(['@/components/hospitalization_report_exam_details'], resolve),
      /*住院检查报告-报告详情*/
      meta: {
        title: '报告详情',
        isDetail: true
      }
    },
    {
      path: '/previewPdf',
      name: 'previewPdf',
      component: resolve => require(['@/components/common/showPdf'], resolve),
      /*住院检查报告-报告详情*/
      meta: {
        title: '报告详情',
        isDetail: true
      }
    }, {
      path: '/hospitalizationChargeRecord',
      name: 'hospitalizationChargeRecord',
      component: resolve => require(['@/components/hospitalization_charge_record'], resolve),
      /*住院押金记录*/
      meta: {
        title: '住院押金记录'
      }
    }, {
      path: '/hospitalizationChargeRecordDetails',
      name: 'hospitalizationChargeRecordDetails',
      component: resolve => require(['@/components/hospitalization_charge_record_details'], resolve),
      /*住院押金记录详情*/
      meta: {
        title: '住院押金记录详情'
      }
    }, {
      path: '/hospitalizationBill',
      name: 'hospitalizationBill',
      component: resolve => require(['@/components/hospitalization_bill'], resolve),
      meta: {
        title: '住院记录'
      }
    }, {
      path: '/hospitalizationBillDetail',
      name: 'hospitalizationBillDetail',
      component: resolve => require(['@/components/hospitalization_bill_detail'], resolve),
      meta: {
        title: '费用明细'
      }
    }, {
      path: '/payRecordNot',
      name: 'payRecordNot',
      component: resolve => require(['@/components/pay_record_not'], resolve),
      /*未缴费记录*/
      meta: {
        title: '缴费记录',
        // keepAlive: true
      }
    }, {
      path: '/payDetailsNot',
      name: 'payDetailsNot',
      component: resolve => require(['@/components/pay_details_not'], resolve),
      /*未缴费记录-详情*/
      meta: {
        title: '缴费详情'
      }
    }, {
      path: '/payRecordAlready',
      name: 'payRecordAlready',
      component: resolve => require(['@/components/pay_record_already'], resolve),
      /*已缴费记录*/
      meta: {
        title: '待缴费',
        // keepAlive: true
      }
    }, {
      path: '/payDetailsAlready',
      name: 'payDetailsAlready',
      component: resolve => require(['@/components/pay_details_already'], resolve),
      /*已缴费记录-详情*/
      meta: {
        title: '缴费详情'
      }
    }, {
      path: '/payWx',
      name: 'payWx',
      component: resolve => require(['@/components/pay_wx'], resolve),
      /*诊疗费 微信去缴费*/
      meta: {
        title: '缴费-诊疗费'
      }
    }, {
      path: '/payWxBack',
      name: 'payWxBack',
      component: resolve => require(['@/components/pay_wx_back'], resolve),
    }, {
      path: '/payAli',
      name: 'payAli',
      component: resolve => require(['@/components/pay_Ali'], resolve),
      /*诊疗费 支付宝去缴费*/
      meta: {
        title: '缴费-诊疗费'
      }
    }, {
      path: '/registerNotice',
      name: 'registerNotice',
      component: resolve => require(['@/components/register_notice'], resolve),
      /*就诊须知*/
      meta: {
        title: '就诊须知'
      }
    }, {
      path: '/chooseDepartment',
      name: 'chooseDepartment',
      component: resolve => require(['@/components/register_choose_department'], resolve),
      /*选择科室*/
      meta: {
        title: '选择科室',
      }
    }, {
      path: '/chooseDoctor',
      name: 'chooseDoctor',
      component: resolve => require(['@/components/register_choose_doctor'], resolve),
      /*选择医生*/
      meta: {
        title: '选择医生',
      }
    }, {
      path: '/chooseTime',
      name: 'chooseTime',
      component: resolve => require(['@/components/register_choose_time'], resolve),
      meta: {
        title: '医生挂号'
      }
    }, {
      path: '/chooseTime1',
      name: 'chooseTime1',
      component: resolve => require(['@/components/register_choose_time1'], resolve),
      meta: {
        title: '确认挂号'
      }
    }, {
      path: '/myreserve',
      name: 'myreserve',
      component: resolve => require(['@/components/register_my_reserve'], resolve),
      meta: {
        title: '我的预约'
      }
    }, {
      path: '/myguahao',
      name: 'myguahao',
      component: resolve => require(['@/components/register_my_guahao'], resolve),
      meta: {
        title: '我的挂号'
      }
    }, {
      path: '/myreserveDetail',
      name: 'myreserveDetail',
      component: resolve => require(['@/components/register_my_reserve_details'], resolve),
      meta: {
        title: '预约详情'
      }
    }, {
      path: '/myguahaoDetail',
      name: 'myguahaoDetail',
      component: resolve => require(['@/components/register_my_guahao_details'], resolve),
      meta: {
        title: '挂号详情'
      }
    }, {
      path: '/regonline',
      name: 'regonline',
      component: resolve => require(['@/components/register_online_number'], resolve),
      meta: {
        title: '挂号记录',
        // keepAlive: true
      }
    }, {
      path: '/regonlinedetail',
      name: 'regonlinedetail',
      component: resolve => require(['@/components/register_online_number_paydetails'], resolve),
      meta: {
        title: '挂号详情'
      }
    }, {
      path: '/regpaywx',
      name: 'regpaywx',
      component: resolve => require(['@/components/register_pay_wx'], resolve),
      /*挂号支付-微信*/
      meta: {
        title: '挂号支付'
      }
    }, {
      path: '/regpayali',
      name: 'regpayali',
      component: resolve => require(['@/components/register_pay_ali'], resolve),
      /*挂号支付-支付宝*/
      meta: {
        title: '挂号支付'
      }
    }, {
      path: '/noticelist',
      name: 'noticelist',
      component: resolve => require(['@/components/article-list'], resolve),
      /*公告列表页*/
      meta: {
        title: '公告列表'
      }
    }, {
      path: '/noticedetail',
      name: 'noticedetail',
      component: resolve => require(['@/components/article-detail'], resolve),
      /*公告详情页*/
      meta: {
        title: '公告详情'
      }
    }, {
      path: '/hospitalnav',
      name: 'hospitalNav',
      component: resolve => require(['@/components/hospital_navgation'], resolve),
      /*来院导航*/
      meta: {
        title: '来院导航'
      }
    }, {
      path: '/addCard',
      name: 'addMedicalCard',
      component: resolve => require(['@/components/addMedicalCard'], resolve),
      /*绑定社保卡*/
      meta: {
        title: '绑定社保卡'
      }
    }, {
      path: '/addCardHealth',
      name: 'addCardHealth',
      component: resolve => require(['@/components/addCardHealth'], resolve),
      /*微信绑定社保卡*/
      meta: {
        title: '授权建档'
      }
    }, {
      path: '/hospitalinfo',
      name: 'hospitalinfo',
      component: resolve => require(['@/components/article-detail'], resolve),
      meta: {
        title: '医院简介'
      }
    }, {
      path: '/valuablebook',
      name: 'valuablebook',
      component: resolve => require(['@/components/article-detail'], resolve),
      meta: {
        title: '就诊指南'
      }
    }, {
      path: '/expertlist',
      name: 'expertlist',
      component: resolve => require(['@/components/article-detail'], resolve),
      meta: {
        title: '专家坐诊表'
      }
    }, {
      path: '/ruyuan',
      name: 'ruyuan',
      component: resolve => require(['@/components/article-detail'], resolve),
      meta: {
        title: '入院流程'
      }
    }, {
      path: '/chuyuan',
      name: 'chuyuan',
      component: resolve => require(['@/components/article-detail'], resolve),
      meta: {
        title: '出院流程'
      }
    }, {
      path: '/hospitalguidelist',
      name: 'hospitalguidelist',
      component: resolve => require(['@/components/hospital-guide-list'], resolve),
      meta: {
        title: '就诊指南'
      }
    }, {
      path: '/hospitalguidedetail',
      name: 'hospitalguidedetail',
      component: resolve => require(['@/components/article-detail'], resolve),
      meta: {
        title: '就诊指南'
      }
    }, {
      path: '/hospitalsuggest',
      name: 'hospitalsuggest',
      component: resolve => require(['@/components/hospital-suggest'], resolve),
      meta: {
        title: '建议反馈'
      }
    }, {
      path: '/nocard',
      name: 'nocard',
      component: resolve => require(['@/components/outpatient_patient_add_no_card'], resolve),
      meta: {
        title: '无卡预约'
      }
    }, {
      path: '/paycode',
      component: resolve => require(['@/components/pay_code'], resolve),
      meta: {
        title: '医嘱缴费凭证'
      }
    },
    {
      path: '/apptime',
      component: resolve => require(['@/components/register_choose_apptime'], resolve),
      meta: {
        title: '预约挂号'
      }
    },
    {
      path: '/selfbilling',
      component: resolve => require(['@/components/self_billing'], resolve),
      meta: {
        title: '自助开单'
      }
    },
    {
      path: '/selfbillingrecord',
      component: resolve => require(['@/components/self_billing_record'], resolve),
      meta: {
        title: '开单记录'
      }
    },
    {
      path: '/questionNaire',
      component: resolve => require(['@/components/question_naire'], resolve),
      meta: {
        title: '核酸检测调查问卷'
      }
    },
    {
      path: '/hosList',
      component: resolve => require(['@/components/hospitalization_list'], resolve),
      meta: {
        title: '住院清单列表'
      }
    },
    {
      path: "/registration",
      name: "registration",
      component: (resolve) => require(["@/components/registration"], resolve),
      meta: {
        title: "调查问卷",
      },
    },
    {
      path: '/relist',
      component: resolve => require(['@/components/hospitalization_relist'], resolve),
      meta: {
        title: '住院充值记录' //住院押金清单列表
      }
    },
    //协议
    {
      path: '/userTerms',
      name: 'userTerms',
      component: resolve => require(['@/components/user-terms'], resolve),
      meta: {
        title: '用户使用协议'
      }
    },
    {
      path: '/userPrivacyTerms',
      name: 'userPrivacyTerms',
      component: resolve => require(['@/components/user-privacy-terms'], resolve),
      meta: {
        title: '隐私保护协议'
      }
    },
    {
      path: '/invoiceMz',
      name: 'invoiceMz',
      component: resolve => require(['@/components/invoices-mz'], resolve),
      meta: {
        title: '门诊发票'
      }
    },
    {
      path: '/invoiceZy',
      name: 'invoiceZy',
      component: resolve => require(['@/components/invoices-zy'], resolve),
      meta: {
        title: '住院发票'
      }
    },
    {
      path: '/vaccinepage',
      name: 'vaccinepage',
      component: resolve => require(['@/components/vaccinepage'], resolve),
      meta: {
        title: '疫苗预约'
      }
    },
    {
      path: '/vaccineAppoint',
      name: 'vaccineAppoint',
      component: resolve => require(['@/components/vaccineAppoint'], resolve),
      meta: {
        title: '疫苗预约'
      }
    },
    // vaccinatedpeople
    {
      path: '/vaccinatedpeople',
      name: 'vaccinatedpeople',
      component: resolve => require(['@/components/vaccinatedpeople'], resolve),
      meta: {
        title: '接种人信息'
      }
    },
    {
      path: '/vaccinatedpeoplelist',
      name: 'vaccinatedpeoplelist',
      component: resolve => require(['@/components/vaccinatedpeoplelist'], resolve),
      meta: {
        title: '接种人列表'
      }
    },
    // vaccineAppointDate
    {
      path: '/vaccineAppointDate',
      name: 'vaccineAppointDate',
      component: resolve => require(['@/components/vaccineAppointDate'], resolve),
      meta: {
        title: '预约'
      }
    },
    {
      path: '/vaccineAppointList',
      name: 'vaccineAppointList',
      component: resolve => require(['@/components/vaccineAppointList'], resolve),
      meta: {
        title: '预约列表'
      }
    },
    {
      path: '/vaccineAppointError',
      name: 'vaccineAppointError',
      component: resolve => require(['@/components/vaccineAppointError'], resolve),
      meta: {
        title: '预约状态'
      }
    },
    {
      path: '/yibaoAuthTest',
      component: resolve => require(['@/components/yibao_auth_test'], resolve),
      meta: {
        title: '获取医保编码'
      }
    }, {
      path: '/yibaoPay',
      component: resolve => require(['@/components/pay-yibao/index'], resolve),
      meta: {
        title: '确认支付'
      }
    }, {
      path: '/familyYb',
      component: resolve => require(['@/components/pay-yibao/family-yb'], resolve),
      meta: {
        title: '医保亲情付'
      }
    }, {
      path: '/docSkillOrder',
      component: resolve => require(['@/components/doc-skill-order'], resolve),
      meta: {
        title: '医技预约'
      }
    }, {
      path: '/docSkillOrderInfo',
      component: resolve => require(['@/components/doc-skill-order-info'], resolve),
      meta: {
        title: '预约详情'
      }
    }, {
      path: '/ceshi',
      component: resolve => require(['@/components/ceshi'], resolve),
      meta: {
        title: '测试医保'
      }
    },
    {
      path: '/settlement-index',
      component: resolve => require(['@/view/settlement/index'], resolve),
      meta: {
        title: '出院结算'
      }
    },
    {
      path: '/settlement-detail',
      component: resolve => require(['@/view/settlement/detail'], resolve),
      meta: {
        title: '待结算详情'
      }
    },
    {
      path: '/settled-detail',
      component: resolve => require(['@/view/settlement/detail-settled'], resolve),
      meta: {
        title: '已结算详情'
      }
    },
    {
      path: '/settlement-pre-settle',
      component: resolve => require(['@/view/settlement/pre-settle'], resolve),
      meta: {
        title: '预结算确认'
      }
    },
    {
      path: '/settlement-insurance',
      component: resolve => require(['@/view/settlement/preSettlement'], resolve),
      meta: {
        title: '医保结算支付'
      }
    },
    {
      path: '/settlement-result',
      component: resolve => require(['@/view/settlement/result'], resolve),
      meta: {
        title: '出院结算详情'
      }
    },

  ],
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return {
      x: 0,
      y: 0
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js